<div class="ion-padding idp-regisztracio">
  <h2><ion-icon name="globe-outline"></ion-icon> Mobil app – IdP-címtár</h2>
  <p class="halvany">
    A mobil app belépés ELŐTTI intézmény-választójához ez a deploy <b>önregisztrál</b> a központi címtárba.
    Töltsd ki az adatokat → <b>Mentés</b> → <b>Regisztráció a központhoz</b>. A registry-kulcs titkosítva tárolódik.
  </p>

  <ion-card>
    <ion-card-header><ion-card-title>Beállítások</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="racs">
        <ion-item>
          <ion-label position="stacked">Központi címtár URL (worker)</ion-label>
          <ion-input [(ngModel)]="form.directory_url" placeholder="pl. naplo-idp-directory.<acc>.workers.dev" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Registry kulcs {{ van_kulcs ? '(mentve – csak cseréhez töltsd ki)' : '' }}</ion-label>
          <ion-input type="password" [(ngModel)]="form.registry_key" placeholder="REGISTRY_KEY" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Megjelenített intézménynév</ion-label>
          <ion-input [(ngModel)]="form.nev" placeholder="pl. Zenit Iskola"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Base domain (deploy)</ion-label>
          <ion-input [(ngModel)]="form.base_domain" placeholder="pl. zenit.sulinform.hu" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Logó URL (opcionális)</ion-label>
          <ion-input [(ngModel)]="form.logo" placeholder="https://…/logo.png" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Sorrend (kisebb elöl)</ion-label>
          <ion-input type="number" [(ngModel)]="form.sorrend"></ion-input>
        </ion-item>
      </div>

      <p class="halvany szekcio">
        <b>Egyedi szolgáltatás-URL-ek</b> — CSAK akkor töltsd ki, ha a deploy NEM a
        <code>&lt;szolgáltatás&gt;.&lt;base_domain&gt;</code> mintát követi (pl. dev Cloudflare tunnel, egyedi domain).
        Üresen hagyva az app a base domainből derivál: <code>erp./idp./avatars./forum./n8n.&lt;base_domain&gt;</code>.
      </p>
      <div class="racs">
        <ion-item>
          <ion-label position="stacked">IdP (Keycloak) URL</ion-label>
          <ion-input [(ngModel)]="form.idp" placeholder="https://idp.zenit.sulinform.hu" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">API/ERP (backend) URL</ion-label>
          <ion-input [(ngModel)]="form.api" placeholder="https://erp.zenit.sulinform.hu" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Avatars URL</ion-label>
          <ion-input [(ngModel)]="form.avatars" placeholder="https://avatars.zenit.sulinform.hu" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Fórum URL</ion-label>
          <ion-input [(ngModel)]="form.forum" placeholder="https://forum.zenit.sulinform.hu" autocapitalize="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">n8n URL</ion-label>
          <ion-input [(ngModel)]="form.n8n" placeholder="https://n8n.zenit.sulinform.hu" autocapitalize="off"></ion-input>
        </ion-item>
      </div>
      <div class="gombok">
        <ion-button (click)="ment()"><ion-icon slot="start" name="save-outline"></ion-icon> Mentés</ion-button>
        <ion-button color="primary" [disabled]="fut" (click)="regisztral()">
          <ion-icon slot="start" [name]="fut ? 'hourglass-outline' : 'cloud-upload-outline'"></ion-icon>
          Regisztráció a központhoz
        </ion-button>
        <ion-button color="danger" fill="outline" [disabled]="fut" (click)="torol()">
          <ion-icon slot="start" name="trash-outline"></ion-icon> Kivétel a központból
        </ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="utolso_reg || utolso_eredmeny">
    <ion-card-header><ion-card-title>Utolsó regisztráció</ion-card-title></ion-card-header>
    <ion-card-content>
      <p class="halvany" *ngIf="utolso_reg"><small>{{ utolso_reg }}</small></p>
      <p><small>{{ utolso_eredmeny }}</small></p>
    </ion-card-content>
  </ion-card>
</div>
